import { styled, keyframes } from '@mui/material/styles';
import { Box, Button, Typography } from '@mui/material';
import pharma from '../../assets/pharma.png';

const COLORS = {
  green:  '#45c047',
  blue:   'rgb(37, 99, 235)',
  yellow: '#ffc800',
  red:    '#ff0000c2',
  purple: 'rgb(79, 70, 229)',
  orange: 'rgb(255, 137, 4)'
};

export const MainContainer = styled(Box)(({ theme }) => ({
  width:'100%',
  background:'transparent'
}))

export const HeroContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  minHeight: '100vh',
  boxSizing: 'border-box',
  backgroundColor: '#FFFBFF',
  alignItems: 'stretch',

  // ✅ Tablet = SAME as mobile
  [theme.breakpoints.between('sm', 'md')]: {
    flexDirection: 'column',
    width: '100%',
    padding: 0,

    '& > *:nth-of-type(2)': {
      display: 'none',
    },
    '& > *:first-of-type': {
      // width: '100%',
      maxWidth: '100vw',
    },
  },

  // Mobile portrait
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    width: '100%',
    '& > *:nth-of-type(2)': { display: 'none' },
    '& > *:first-of-type': {
      width: '100%',
      // maxWidth: '100vw',
    },
  },

  // Mobile landscape
  '@media (max-width:600px) and (orientation: landscape)': {
    flexDirection: 'column',
    width: '100%',
    padding: theme.spacing(1),
    '& > *:nth-of-type(2)': { display: 'none' },
    '& > *:first-of-type': {
      width: '100%',
      // maxWidth: '100vw',
    },
  },
}));


export const LeftSection = styled(Box)(({ theme }) => ({
  flex: 1,
  paddingLeft: '100px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',

  // MOBILE (centered)
  [theme.breakpoints.down('sm')]: {
    background: `url(${pharma}) 0% center / cover no-repeat`,
    paddingLeft: '0px',
    alignItems: 'center',
    textAlign: 'left',

    // ✅ add overlay only on mobile/tablet
  '&::before': {
    content: '""',
    position: 'absolute',
    inset: 0,
    background: 'linear-gradient(90deg, rgba(255,255,255,0.5) 0%, rgba(255,255,255,0.0) 100%)',
    pointerEvents: 'none',
  },
  '& > *': { position: 'relative', zIndex: 1 },
  },

  // ✅ TABLET ONLY (left aligned)
  [theme.breakpoints.between('sm', 'md')]: {
    background: `url(${pharma}) -30% center / cover no-repeat`,
    paddingLeft: '40px',          // optional, tweak as needed
    alignItems: 'flex-start',
    textAlign: 'left',
  },
  
  '@media (orientation: landscape) and (max-height: 450px)': {
    paddingTop:'100px',
    boxSizing:'border-box'
  },

}));


// export const RightSection = styled(Box)(({ theme }) => ({
//   flex: 1,
//   padding: 0,
//   display: 'flex',
//   alignItems: 'center',
//   justifyContent: 'center',
//   '& img': {
//     width: '100%',
//     height: '100%',
//     objectFit:'cover',
//     display:'block',
    
//     // borderRadius: '8px',
//   },
// }));

export const RightSection = styled(Box)(({ theme }) => ({
  flex: 1,
  position: 'relative',
  padding: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundImage: `url(${pharma})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  overflow: 'hidden',

  '&::before': {
    content: '""',
    position: 'absolute',
    inset: 0,
    // background: 'linear-gradient(135deg, rgba(8,12,28,0.2) 0%, rgba(8,12,28,0.45) 100%)',
    zIndex: 1,
  },

  '& > *': {
    position: 'relative',
    zIndex: 2,
  },
}));

export const Subheading = styled(Typography)(({ theme }) => ({
  fontSize: '1.2rem',
  color: '#555',
  margin: 0,

  '@media (orientation: landscape) and (max-height: 450px)': {
    fontSize: '1rem',
  },
  
}));

export const Heading = styled(Typography)(({ theme }) => ({
  fontSize: '4rem',
  margin: `${theme.spacing(1)} 0`,
  fontWeight: '500',
  fontFamily:'Montserrat',
  marginLeft:'-5px',
  [theme.breakpoints.down('sm')]: {
    fontSize:'3rem' 
},

'@media (orientation: landscape) and (max-height: 450px)': {
    fontSize:'2.5rem'
  },
  
}));

export const Heading2 = styled(Typography)(({ theme }) => ({
  fontSize: '2.5rem',
  margin: `${theme.spacing(1)} 0`,
  fontWeight: '500',
  
}));

export const Heading3 = styled(Typography)(({ theme }) => ({
  fontSize: '2rem',
  margin: `${theme.spacing(1)} 0`,
  fontWeight: '500',
}));

export const Description = styled(Typography)(({ theme }) => ({
  fontSize: '1.2rem',
  lineHeight: 1.5,
  color: '#333',
  margin: theme.spacing(1, 0),

  // TABLET
  [theme.breakpoints.between('sm', 'md')]: {
    fontSize: '1.05rem',
    // width:'50%'
  },

  // MOBILE
  [theme.breakpoints.down('sm')]: {
    fontSize: '1rem',
  },

  '@media (orientation: landscape) and (max-height: 450px)': {
    fontSize: '0.85rem',
    width:'100%'
  },
}));

export const ButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(3),
  marginTop:'50px',


  '@media (orientation: landscape) and (max-height: 450px)': {
    marginTop:'20px'
  },
  
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  background:'linear-gradient(45deg, #FDA15F 0%, #EB2172 50%, #A333CF 100%)',
//   backgroundColor: '#333',
transition: 'background 3s ease-in-out 0s',
  minWidth:'150px',
  fontSize:'1rem',
//   fontWeight:'normal',
  color: '#fff',
  // border:'2px solid #333',
  borderRadius: '50px',
  textTransform: 'none',
  padding: '10px 25px 15px 25px',
  '&:hover': {
    background:'linear-gradient(-90deg, #A333CF 0%, #3898ec 100%)',
  },

  '@media (orientation: landscape) and (max-height: 450px)': {
    minWidth:'110px',
    padding: '10px',
    fontSize:'0.8rem',
  },
}));

export const DemoButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(3),
  marginTop: '25px',
  width: '50%',

  // ✅ iPad / tablet: left-align and let width shrink to content
  [theme.breakpoints.between('sm', 'md')]: {
    width: 'auto',
    justifyContent: 'flex-start',
  },

  // ✅ phone: keep it centered full-width (as you had before visually)
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    justifyContent: 'center',
  },

  '@media (orientation: landscape) and (max-height: 450px)': {
    marginTop: '20px',
    marginBottom:'20px',
  },
}));

export const DemoButton = styled(Button)(({ theme }) => ({
  display:'flex',
  width:'324px',
  // background: `
  // linear-gradient(#ffffff, #ffffff) padding-box,
  //   linear-gradient(135deg, rgba(255, 122, 24), rgba(255, 61, 129), rgba(143, 92, 255)) border-box
  // `,
  background:'linear-gradient(135deg, rgba(255, 122, 24, 0.1), rgba(255, 61, 129, 0.1), rgba(143, 92, 255, 0.1)) border-box',
// transition: 'background 3s ease-in-out 0s',
  minWidth:'150px',
  fontSize:'1rem',
//   fontWeight:'normal',
  color: '#8f5cff',
  border: "2px solid transparent",
  borderRadius: '10px',
  textTransform: 'none',
  padding: '10px 25px 10px 25px',
  '&:hover': {
    background:'linear-gradient(135deg, rgba(255, 122, 24, 0.3), rgba(255, 61, 129, 0.3), rgba(143, 92, 255, 0.3)) border-box',
  },
  

  '@media (orientation: landscape) and (max-height: 450px)': {
    minWidth:'110px',
    padding: '5px 10px',
    fontSize:'0.8rem',
  },

    [theme.breakpoints.down('md')]: {
    width: 'auto',          // 🔹 shrink to content, similar width to other buttons
    margin: 0,              // 🔹 don’t force full-width centering
    background: 'rgba(255, 255, 255, 0.3)',
        backdropFilter: 'blur(16px)',
        WebkitBackdropFilter: 'blur(16px)',
        border: '1px solid rgba(255,255,255,0.35)',
        boxShadow: '0 12px 28px rgba(0,0,0,0.08)',

    color: '#fff',
    borderRadius: '10px',

    '&:hover': {
      background: `
        linear-gradient(#ffffff, #ffffff) padding-box,
        linear-gradient(135deg, rgba(255, 122, 24), rgba(255, 61, 129), rgba(143, 92, 255)) border-box
      `,
    },
  },
}));

export const DemoButtonLabel = styled("span")({
  display: "flex",
  justifyContent:'center',
  alignItems:'center',
  background: "linear-gradient(135deg, #ff7a18, #ff3d81, #8f5cff)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
});


export const PricingContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4),
  backgroundColor: '#FFFBFF',
  minHeight: '100vh',
}));

export const PlanGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
  gap: theme.spacing(4),
  marginTop: theme.spacing(4),
}));

export const PlanCard = styled(Box)(({ theme }) => ({
  border: '1px solid #ddd',
  borderRadius: '16px',
  boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
  padding: theme.spacing(3),
  textAlign: 'center',
  backgroundColor: '#fff',
}));

export const PlanHeader = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  padding: theme.spacing(1),
  borderRadius: '8px',
}));

export const PlanContent = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const PlanButton = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));


/* --- ABOUT SECTION --- */
export const AboutSection = styled(Box)(({ theme }) => ({
  width: '100%',
  backgroundColor: '#FFF',
  padding: theme.spacing(8, 4),
  boxSizing:'border-box',

  '@media (orientation: landscape) and (max-height: 450px)': {
    paddingLeft:0,
    paddingRight:0
  },
}));

export const AboutContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(4),
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}));

export const AboutLeft = styled(Box)(({ theme }) => ({
  flex: 1,
  paddingLeft:'50px',
  paddingRight:'50px',
  [theme.breakpoints.up('md')]: {
    paddingRight: theme.spacing(2),
  },
  [theme.breakpoints.down('sm')]: {
    paddingLeft:0,
    paddingRight:0
  },
}));

export const AboutRight = styled(Box)(({ theme }) => ({
  flex: 1,
  display:'flex',
  justifyContent:'center',
  // background:'pink',
  '& img': {
    width: '75%',
    height: 'auto',
    borderRadius: '8px',
    objectFit: 'cover',
  },

  '@media (orientation: landscape) and (max-height: 450px)': {
    '& img': {
    width: '50%',
  },
  },
}));

/* --- FEATURES SECTION --- */
export const FeaturesSection = styled(Box)(({ theme }) => ({
  width: '100%',
  backgroundColor: '#f9f9f9',
  padding: theme.spacing(8, 4),
  boxSizing:'border-box'
}));

export const FeaturesContent = styled(Box)(({ theme }) => ({
  maxWidth: '1200px',
  margin: '0 auto',

}));

export const FeatureGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  gap: theme.spacing(4),
  marginTop: theme.spacing(6),

  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: theme.spacing(3),
  },

  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
    gap: theme.spacing(2.5),
  },
}));


export const FeatureCard = styled(Box)(({ theme }) => ({
  backgroundColor: '#fff',
  borderRadius: '25px',
  boxShadow: '0 2px 4px rgba(0,0,0,0.08)',
  padding: theme.spacing(2),
  paddingTop:'35px',
  textAlign: 'center',
  display:'flex',
  flexDirection:'column',
  // justifyContent:'center',
  alignItems:'center',
  height:'400px',
  width:'auto'
}));

export const FeatureTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(0),
  marginTop: theme.spacing(3),
  fontWeight: 'bold',
}));

export const FeatureDesc = styled(Typography)(({ theme }) => ({
  color: '#555',
  marginBottom:'15px',
  // fontWeight:'500',
  textAlign:'left'
}));

// --- 2x2 grid container ---
export const CardletContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: theme.spacing(2.5),
  marginTop:'48px',
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
  },
}));

// --- cardlet row (icon left, text right) ---
export const Cardlet = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  padding: theme.spacing(2),
  background: '#fff',
  borderRadius: 16,
  // border:'1px solid #ededed',
  boxShadow: '0 1px 4px rgba(0,0,0,0.05)',
}));

// --- pulsating ring animation ---
const ping = keyframes`
  0%   { transform: scale(1);   opacity: .75; }
  50%  { transform: scale(1.4); opacity: 0;   }
  100% { transform: scale(1);   opacity: .75; }
`;

// --- circular icon bubble with pulse ---
export const IconBubble = styled(Box, {
  shouldForwardProp: (prop) => prop !== '$color',
})(({ $color = 'blue' }) => {
  const c = COLORS[$color] || COLORS.blue;
  return {
    position: 'relative',
    width: 48,
    height: 48,
    minWidth: 48,
    borderRadius: '50%',
    backgroundColor: c,
    color: '#fff',
    display: 'grid',
    placeItems: 'center',
    overflow: 'visible',

    // breathing pulse
    '::after': {
      content: '""',
      position: 'absolute',
      inset: 0,
      borderRadius: '50%',
      border: `3.5px solid ${c}`,
      animation: `${ping} 5s ease-in-out infinite`,
    },
  };
});

// --- title text ---
export const CardletTitle = styled(Typography)({
  fontSize: '1rem',
  fontWeight: 600,
});


/* --- PRICING SECTION --- */

export const PricingHeader = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  fontWeight: 'bold',
}));

export const PricingPlans = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  gap: theme.spacing(3),
}));

export const PricingCardBox = styled(Box)(({ theme }) => ({
  width: '350px',
  backgroundColor: '#fff',
  borderRadius: '8px',
  boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
  padding: theme.spacing(3,4),
  textAlign: 'left',

  [theme.breakpoints.down('sm')]: {
    width:'auto',
  
},
}));

export const PricingCardTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(5),
  fontWeight: 'bold',
  fontSize: '1.5rem',
}));

export const PricingCardDesc = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(5),
  color: '#555',
}));


/* PRICING SECTION */
export const PricingSection = styled(Box)(({ theme }) => ({
  width: '100%',
  backgroundColor: '#FFF',
  padding: theme.spacing(8, 4),
  boxSizing:'border-box'
}));

export const PricingContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(4),
  justifyContent: 'center',     // ✅ centers columns
  alignItems: 'flex-start',
  maxWidth: 1200,               // ✅ keeps it from stretching too wide
  margin: '0 auto',             // ✅ centers the whole block
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    alignItems: 'center',       // ✅ centers card + right text when stacked
  },
}));

export const PricingLeft = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  justifyContent: 'center',     // ✅ centers the card inside left column
  paddingLeft: 0,               // ✅ REMOVE the 75px
  [theme.breakpoints.down('sm')]: {
    marginBottom: '50px',
  },
}));

export const PricingRight = styled(Box)(({ theme }) => ({
  flex: 1,
  paddingRight: 0,              // ✅ REMOVE the 75px
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',         // ✅ centers the whole “Secure Payments” block
  textAlign: 'center',          // ✅ nicer on tablet
  [theme.breakpoints.up('lg')]: {
    alignItems: 'flex-start',   // optional: left align on desktop
    textAlign: 'left',
  },
}));


export const PaymentMethods = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',  // 4 columns for 4 cards
  gap: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: 'repeat(3, 1fr)', // fewer columns on mobile
  },
}));

export const PaymentCard = styled(Box)(({ theme }) => ({
  width:'75px',
  backgroundColor: '#f9f9f9',
  borderRadius: '8px',
  boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(1),
  '& img': {
    width: '100%',
    height: 'auto',
    borderRadius:'8px'
  },
}));

export const ContactSection = styled(Box)(({ theme }) => ({
  width: '100%',
  backgroundColor: '#FFF',
  padding: theme.spacing(8, 4),
  boxSizing: 'border-box',
  textAlign: 'center',
}));

export const ContactContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(4),
}));

export const ContactItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
}));


